// extracted by mini-css-extract-plugin
module.exports = {"container":"section-module--container--2EpCX"};